import { ActionsHook } from "@/lib/Components/Actions/ActionGroupButtons";
import {
  PencilIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "@tanstack/react-router";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { TripEditDialog } from "@/app/Cities/Trips/Components/TripEditDialog";

export function useTripActions(): ActionsHook<{ id: string }> {
  const { open } = useDialog(TripEditDialog);
  const navigate = useNavigate();

  return (trip) => {
    return [
      {
        label: "Actions",
        items: [
          {
            actions: [
              {
                label: "Change route",
                Icon: PencilIcon,
                handleAction: () => {
                  open({
                    tripId: trip.id,
                  });
                },
              },
              {
                label: "Edit FAQs",
                Icon: QuestionMarkCircleIcon,
                handleAction: () => {
                  navigate({
                    from: "/$tenant/$orgId/supplier/{-$supplierId}",
                    to: "/$tenant/$orgId/supplier/{-$supplierId}/admin/trips/$tripId/faqs",
                    params: (prev) => ({ ...prev, tripId: trip.id }),
                  });
                },
              },
            ],
          },
        ],
      },
    ];
  };
}
